module.exports = __webpack_public_path__ + "static/media/angel_event.68214a35.jpg";